import { createSlice } from '@reduxjs/toolkit';

export const pubinvitesSlice = createSlice({
  name: 'pubinvites',
  initialState: {
    value: []
  },
  reducers: {
    setPubInvites: (state, action) => {
      state.value = action.payload;
    }
  }
});

export const { setPubInvites } = pubinvitesSlice.actions;

export default pubinvitesSlice.reducer;
